export class DatePickerAdaptor {
	pickers = [];
	
	addPickers (object){
		if (Array.isArray (object))
			object.forEach (picker => this.pickers.push (picker));
		else
			this.pickers.push (object);
	}

	setDatePickerValue (inputId, date) {
	    const picker = Array.isArray (this.pickers) ? 
	        this.pickers.find (p => p.element.id === inputId) : 
	        this.pickers.element.id === inputId ? this.pickers : null;

	    if (picker)
	        picker.setDate(date, true);
	}

	toggleDatePicker (inputId, enable){
	    const picker = Array.isArray (this.pickers) ? 
	        this.pickers.find(p => p.element.id === inputId) : 
	        this.pickers.element.id === inputId ? this.pickers : null;

	    if (picker){
	        picker.element.disabled = !enable;
	        if (picker.altInput)
	            picker.altInput.disabled = !enable;
	    }
	}
}

if (typeof window !== 'undefined')
	window.DatePickerAdaptor = DatePickerAdaptor;

